import React from 'react';
import InlineTooltip from '../Tooltip/InlineTooltip';

const InputRadio = ({ value, id, label, handleChange, error, helpText, mandatory }) => {
  return (
    <div className='relative mb-4' dzt-field-id={id}>
      <label className="block text-xs font-semibold uppercase tracking-wider text-stride-muted mb-2 flex items-center gap-1.5">
        <span>
          {label} {mandatory && <span className="text-stride-danger">*</span>}
        </span>
        {helpText && (
          <InlineTooltip
            content={helpText}
            imgClass="pt-0.5"
          />
        )}
      </label>
      <div className="flex items-center gap-4">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            id={`${id}-1`}
            type="radio"
            value="true"
            checked={value?.toString() === "true"}
            name={id}
            className="w-4 h-4 text-stride-primary border-stride-border focus:ring-stride-primary"
            onChange={handleChange}
          />
          <span className="text-sm font-medium text-stride-heading">True</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            id={`${id}-2`}
            type="radio"
            value="false"
            checked={value?.toString() === "false"}
            name={id}
            className="w-4 h-4 text-stride-primary border-stride-border focus:ring-stride-primary"
            onChange={handleChange}
          />
          <span className="text-sm font-medium text-stride-heading">False</span>
        </label>
      </div>
      {error && <p className="mt-1.5 text-xs text-stride-danger font-medium">{error}</p>}
    </div>
  );
};

export default InputRadio;
